<div class="jp--skins">
  @if (skins().length === 0) {
  <!-- <button
    class="create button button--style-yellow padding-x-12 h-36"
    (click)="openJoinGame()"
  >
    <app-game-icon icon [game]="'Jackpot'" color="black"></app-game-icon>
    Join Jackpot first!</button
  > -->
  } @else {
  <ul class="jp--skins__list keen-slider" #sliderRef>
    @for (skin of skins(); track $index;) {
    <li class="keen-slider__slide">
      <app-skin class="jp--skin" [skin]="skin" [balanceType]="'skins'" />
    </li>
    }
  </ul>
  }

  <div class="jp--controls">
    <div class="flex items-center gap-4">
      <button
        class="button wager-swiper__control button--style-primary button--style-primary-bordered s-24"
        (click)="sliderMove('prev')"
        [disabled]="currentSlide() === 0"
      >
        <svg-icon
          class="flex items-center justify-center s-16 indicator"
          src="assets/icons/ui/arrow.svg"
          [svgStyle]="{ transform: 'rotate(-90deg)' }"
        />
      </button>
      <button
        class="button button--style-primary button--style-primary-bordered s-24"
        (click)="sliderMove('start')"
        [disabled]="currentSlide() === 0"
      >
        <svg-icon
          class="flex items-center justify-center s-16 indicator"
          src="assets/icons/ui/double-arrow.svg"
        />
      </button>
    </div>
    <div class="flex items-center gap-4">
      <button
        class="button button--style-primary button--style-primary-bordered s-24 gap-4"
        (click)="sliderMove('end')"
        [disabled]="
          currentSlide() >= (slider()?.track?.details?.maxIdx ?? 100) ||
          skins().length === 0
        "
      >
        <svg-icon
          class="flex items-center justify-center s-16 indicator"
          src="assets/icons/ui/double-arrow.svg"
          [svgStyle]="{ transform: 'rotate(180deg)' }"
        />
      </button>

      <button
        class="button button--style-primary button--style-primary-bordered s-24"
        (click)="sliderMove('next')"
        [disabled]="
          currentSlide() >= (slider()?.track?.details?.maxIdx ?? 100) ||
          skins().length === 0
        "
      >
        <svg-icon
          class="flex items-center justify-center s-16 indicator"
          src="assets/icons/ui/arrow.svg"
          [svgStyle]="{ transform: 'rotate(90deg)' }"
        />
      </button>
    </div>
  </div>
</div>
